module.exports = __webpack_public_path__ + "img/upgrade3.ad2e3ea6.png";